/**
 * Screenshot labels emitted while Playwright is still on the sign-in flow.
 * Avoid substring checks like `includes('login')` — they hide valid frames
 * (e.g. "Post-login redirect…", "Catalog").
 */
export function isLoginPhasePortalLabel(label) {
  const s = String(label || '').trim().toLowerCase();
  if (!s) return false;
  if (s.includes('opening login page')) return true;
  if (s.includes('filling in credentials')) return true;
  if (s.includes('login failed')) return true;
  if (s.includes('still on login page')) return true;
  if (/^credential/.test(s)) return true;
  return false;
}
